import { Dispatch, SetStateAction } from 'react';
import MyModal from '../../../../../../../../components/Modal';

interface RemoveEmailModalInterface {
  removeEmailModalShow: boolean;
  emailToRemove: string;
  setRemoveEmailModalShow: Dispatch<SetStateAction<boolean>>;
  removeEmail: () => void;
}

export default function RemoveEmailModal({
  removeEmailModalShow,
  emailToRemove,
  setRemoveEmailModalShow,
  removeEmail,
}: RemoveEmailModalInterface) {
  const message = `Tem certeza que deseja remover o e-mail ${emailToRemove}?`;
  const title = `Remover e-mail ${emailToRemove}`;

  return (
    <MyModal
      show={removeEmailModalShow}
      title={title}
      modalBody={message}
      closeButtonLabel="Fechar"
      actionButtonLabel="Remover"
      onClose={() => setRemoveEmailModalShow(false)}
      onAction={() => removeEmail()}
      type="deleteAction"
    />
  );
}
